<template>
  <div
    v-if="showModal"
    id="showModal"
    class="fixed z-70 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >

      <!-- Modal panel, show/hide based on modal state. -->
      <div
        :class="[
          showModalContents ? 'translate-y-0' : 'translate-y-full opacity-0',
          showModal === 'logout' ? 'bg-transparent' : 'bg-white',
          loaded ? '' : 'bg-truegray-500',
        ]"
        class="transform delay-100 w-full sm:max-w-3xl sm:w-full inline-block rounded-lg px-4 py-12 sm:mt-8 sm:mb-20 sm:p-16 text-left shadow transition-all align-bottom sm:align-middle overflow-visible relative"
      >
        <div v-if="loaded">
          <h3 v-if="showModal === 'resources'">Resources</h3>
          <h3 v-else>Image Resources</h3>
        </div>

        <button
          type="button"
          class="absolute right-4 top-4 lg:top-6 lg:right-4 transform hover:rotate-180 transition-all duration-300 hover:text-primary"
          @click="showModal = false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <MediaItems v-if="showModal === 'resources'" :post="true" />
        <MediaItems
          v-else
          :types="[2]"
          :post="true"
          :image_files_only="true"
          :editor-resources="showModal === 'editorResources'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../js/plugins/event-bus.js'
import MediaItems from './MediaItems.vue'
import * as loadingAnimation from '../components/loading.json'

export default {
  components: { MediaItems },

  data() {
    return {
      showModal: false,
      showModalContents: false,
      loaded: false,
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,
    }
  },

  watch: {
    showModal: {
      handler: function (active) {
        if (!active) {
          this.$set(this, 'showModalContents', false)
          this.$set(this, 'loaded', false)
          EventBus.$emit('closeResourceModal')
        } else {
          setTimeout(() => {
            this.$set(this, 'showModalContents', true)
          }, 100)
        }
      },

      deep: true,
    },
  },

  mounted() {
    EventBus.$on('resources_ready', () => {
      this.$set(this, 'loaded', true)
    })

    EventBus.$on('showResourcesSearchModal', (data) => {
      this.$set(this, 'showModal', data)
    })
  },
}
</script>
